import React, { useState } from "react";
import DOMPurify from "dompurify";
import truncate from "html-truncate";
import { FaStar, FaRegStar } from "react-icons/fa";
import {
  MdPlace,
  MdAccessTime,
  MdWork,
  MdPerson,
  MdBookmark,
} from "react-icons/md";
import WorkerProfileComponent from "./WorkerProfileComponent";
import config from "../../../config/config";

const imgUrl = config.PROFILE_IMAGES_URL;
const avatarDefaultUrl = config.AVATAR_DEFAULT_URL;


function Star({ filled }) {
  if (filled) {
    return <FaStar className="star" />;
  }
  return <FaRegStar className="star" />;
}

const StarRating = ({ rating }) => {
  const totalStars = 5;
  return (
    <div className="star-rating">
      {Array.from({ length: totalStars }).map((_, index) => {
        if (index < rating) {
          return <Star key={index} filled={true} />;
        }
        return <Star key={index} filled={false} />;
      })}
      <span className="rating-value">{rating}</span>
    </div>
  );
};

const UserCard = ({ user, onViewProfile }) => {
  const profileImageUrl = user?.profilePhoto
    ? `${imgUrl}/${user.profilePhoto}`
    : `${avatarDefaultUrl}`;

  const fullName = `${user.firstName} ${user.lastName}`;
  const rawBio =
    user.bioData && user.bioData.bioText ? user.bioData.bioText : "";
  const truncatedBio = truncate(rawBio, 100, {
    byWords: true,
    ellipsis: "...",
  });
  const sanitizedBio = DOMPurify.sanitize(truncatedBio);

  const hasReviews =
    user.reviews && user.reviews.length > 0 && user.reviews[0].reviewerId;
  const firstReviewRating = hasReviews ? user.reviews[0].rating : 0;
  const reviewCount = hasReviews ? user.reviews.length : 0;

  return (
    <div className="user-card">
      <div className="user-photo">
        <img
          src={profileImageUrl}
          alt={`Profile of ${fullName}`}
          className="results-rounded-image"
        />
      </div>

      <div className="user-content">
        <div className="search-workers-results-header">
          <h3>{fullName}</h3>
          <div className="rating-and-reviews">
            <StarRating rating={Math.round(firstReviewRating)} />
            <span className="results-reviews">
              ({reviewCount} {reviewCount === 1 ? "review" : "reviews"})
            </span>
          </div>

          <span className="tag">
            <MdBookmark /> Shortlist
          </span>
        </div>
        <div className="results-details">
          <div className="detail-row">
            <MdWork className="card-icon icon-work" />
            <p>Personal Carer ...</p>
          </div>
          <div className="detail-row">
            <MdPlace className="card-icon icon-place" />
            <p>{user.primaryLocation}</p>
          </div>
          <div className="detail-row">
            <MdAccessTime className="card-icon icon-time" />
            <p>50+ support hours delivered on OSH since 29/09/2021</p>
          </div>
          <div className="usercard-bio">
            <div className="detail-row">
              <p dangerouslySetInnerHTML={{ __html: sanitizedBio }} />
            </div>
          </div>
        </div>
        <button className="user-card-button" onClick={onViewProfile}>
          View {user.firstName}'s Profile
        </button>
      </div>
    </div>
  );
};

export default UserCard;
